import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.css'],
    standalone: false,
})
export class MessageDialogComponent implements OnInit {
    closeTimeout;
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            iconSvgPath: string;
            message: string;
            deleteEnableUndo: boolean;
            closeInterval: number;
        },
        private dialogRef: MatDialogRef<MessageDialogComponent>
    ) {}

    ngOnInit(): void {
        if (this.data.closeInterval && Number(this.data.closeInterval)) {
            this.closeTimeout = setTimeout(() => {
                this.dialogRef.close();
                clearTimeout(this.closeTimeout);
            }, this.data.closeInterval);
        }
    }

    close(flag: boolean) {
        this.dialogRef.close(flag);
    }
}
